module.exports = __webpack_public_path__ + "static/media/28DGC10.29bb3c6d.jpg";